export default __webpack_public_path__ + "static/media/Reddit1.695b1db9.PNG";